import axios from 'axios'
const instance = axios.create({
  baseURL: 'http://api.minsheng360.com',//正式
  // baseURL: 'http://101.34.104.166:1002',//测试
})
export default instance
